module.exports = __webpack_public_path__ + "media/img/iryo/singular-0457180fdc39265762e1e65e58d26a74.svg";